import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-settings-card',
  standalone: true,
  templateUrl: './settings-card.component.html',
  styleUrl: './settings-card.component.scss',
})
export class SettingsCardComponent {
  @Input({ required: true }) title = '';
  @Input({ required: true }) description = '';
  @Input({ required: true }) icon = '';
  @Input() badge: string | null = null;
}
